import { makeStyles } from "$components/mui-styles";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import DashboardIcon from "./DashboardIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    "&": `
      transition: background-color 0.3s ease-in;
    `,
    "&:hover": `
      background-color: ${theme.palette.grey[100]};
    `,
  },
  textWrap: {
    whiteSpace: "normal",
  },
}));

const StyledOpenInNewIcon = styled(OpenInNewIcon)({
  marginLeft: 8,
});

export const DashboardLink = ({ dashboardURL, label }) => {
  const classes = useStyles();

  return (
    <ListItem
      button
      component="a"
      target="_blank"
      classes={classes}
      href={dashboardURL}
    >
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText
        primary={label}
        primaryTypographyProps={{ className: classes.textWrap }}
      />
      <ListItemIcon>
        <StyledOpenInNewIcon />
      </ListItemIcon>
    </ListItem>
  );
};
